export default "__VITE_ASSET__DXOEI5Zt__"